import React from "react";
import "../styles/VideoSection.css";

const VideoSection = () => (
  <section className="video-section">
    <div className="container">
      <div className="video-section-flex">
        <div className="video-container">
          <video
            controls
            width="100%"
            poster=""
            style={{
              maxWidth: "700px",
              borderRadius: "16px",
              boxShadow: "0 4px 24px rgba(42,157,176,0.10)",
            }}
          >
            <source
              src={require("../assets/images/VIDEO.mp4")}
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </div>
        <div className="video-section-text">
          <span style={{ fontWeight: "bold" }}>
            They say that nothing worth doing is easy.
          </span>
          <br /> Like every one of us, I've had my bumps in the road. But if you
          ask me, I'll always tell you that it wouldn't change a thing.
          <br /> <span style={{ fontWeight: "bold" }}>Why?</span> Because
          throughout my journey I've honed my skills and proven that my services
          get results in the real world. So today, you can benefit from my years
          of experience.
        </div>
      </div>
    </div>
  </section>
);

export default VideoSection;
